import CheckSymbol from 'components/elements/symbols/CheckSymbol'
import React from 'react'
import styled from 'styled-components'

/** チェックボタンのポジションのtype定義 */
type PartPositionProps = {
  /** 左のマージン */
  marginLeft?: string
  /** 右のマージン */
  marginRight?: string
  /** 上のマージン */
  marginTop?: string
  /** 下のマージン */
  marginBottom?: string
}

/** CheckItemのtype定義 */
type CheckItemProps = PartPositionProps & {
  /** チェック状態 */
  isChecked: boolean
  /** クリック時のコールバック */
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

/**
 * チェックコンポーネント
 * 選択状態と非選択状態でアイコン表示を変えるコンポーネント
 * @param props CheckItemProps
 * @returns
 */
const CheckItem: React.FC<CheckItemProps> = (props) => {
  const { isChecked, ...rest } = props
  return (
    <StyledDamagedPartCheck {...rest}>
      <CheckSymbol isChecked={isChecked} />
    </StyledDamagedPartCheck>
  )
}

/** left, right, top, bottomの指定を適用するスタイル */
const StyledDamagedPartCheck = styled.div<{
  marginLeft?: string
  marginRight?: string
  marginTop?: string
  marginBottom?: string
}>`
  ${(props): string =>
    props.marginLeft ? `margin-left: ${props.marginLeft};` : ''}
  ${(props): string =>
    props.marginRight ? `margin-right: ${props.marginRight};` : ''}
  ${(props): string =>
    props.marginTop ? `margin-top: ${props.marginTop};` : ''}
  ${(props): string =>
    props.marginBottom ? `margin-bottom: ${props.marginBottom};` : ''}
`

export default CheckItem
